<template>
  <div class="storybook-action-sorted-accordion">
    <div
      class="list accordion-list"
      :style="customStyles"
    >
      <div v-if="mostrarBuscador">
        <f7-searchbar
          v-model:value="searchValue"
          :placeholder="$t('common.search')"
          @searchbar:enable="checkDisabled = true"
          @searchbar:clear="checkDisabled = false"
        />
      </div>

      <ul>
        <li
          v-for="(option, i) in filteredVisibleItems"
          :id="option?.Id ?? i"
          :key="option?.Id ?? i"
          class="accordion-item sorted-accordion"
          :class="isOpened(i)"
          @click="EventClickOption(option, i)"
          @accordion:open="EventAccordionOpen()"
          @accordion:close="EventAccordionClose(option)"
        >
          <div class="item-inner">
            <a
              href="#"
              class="item-content item-link"
            >
              <slot
                name="before"
                :item="option"
              />
              <div v-if="showBadge">
                <span
                  v-if="option.hasOwnProperty(nameElementItem) && option[nameElementItem].length > 0"
                  class="badge"
                > {{ functionCountBadge == null ? option[nameElementItem].length : functionCountBadge(option) }} </span>
              </div>

              <div
                v-if="title != null"
                class="item-title"
              >
                {{ title }}
              </div>

              <div
                v-else
                class="item-title"
              >
                {{ option[titleOption] }}

                <slot
                  class="item-title"
                  name="titleOption"
                  :option="option"
                />
              </div>
            </a>

            <div
              v-if="afterTitle"
              class="item-after padding-horizontal-half"
            >
              <slot
                name="after"
                :item="option"
              />
            </div>
          </div>

          <f7-accordion-content v-if="option.hasOwnProperty(nameElementItem) && !searchWithCheckbox">
            <f7-list media-list>
              <div
                v-if="showCheckbox"
                class="content-checkbox-row padding-horizontal padding-vertical-half"
              >
                <div class="content-checkbox-row__check">
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      :checked="visibleItemsCheckStatus[i]"
                      :disabled="option[nameElementItem].length === 0"
                      @change="CheckAllOption(option, $event.target.checked)"
                    >
                    <i class="icon-checkbox" />
                    {{
                      checkboxRowTitle in option
                        ? option[checkboxRowTitle]
                        : `${checkboxRowTitle} (${option[nameElementItem].length})`
                    }}
                  </label>
                </div>
                <div
                  v-if="afterIcon"
                  class="content-checkbox-row__actions"
                  :class="{
                    disabled: (disabledBtnOptionsNoItemsSelected && numberElementSelected === 0),
                  }"
                  @click="OpenOption(option)"
                >
                  <img src="@/static/icons/ic_afterMenu.svg">
                </div>
              </div>

              <template v-if="!virtualList">
                <div
                  v-for="(suboption, index) in option[nameElementItem]"
                  :key="suboption?.Id ?? index"
                >
                  <slot
                    name="subOption"
                    :item="suboption"
                  >
                    <f7-list class="search-list searchbar-found">
                      <div
                        class="content-list-checkbox-item"
                        :class="{
                          'checked': suboption.checked === true,
                          'disabled-checkbox': suboption.disabled === true,
                        }"
                      >
                        <label
                          v-if="showCheckbox"
                          class="checkbox"
                        >
                          <input
                            :checked="suboption.checked"
                            type="checkbox"
                            @change="ChangeSelected(option, suboption)"
                          >
                          <i class="icon-checkbox" />
                        </label>
                        <div class="content-list-checkbox-item__details">
                          <f7-list-item link="#">
                            {{ suboption[titleSubOption] }}
                            <div v-if="'subOptionSubtitle' in $slots">
                              <slot
                                :item="suboption"
                                name="subOptionSubtitle"
                              />
                            </div>
                          </f7-list-item>
                        </div>
                      </div>
                    </f7-list>
                  </slot>
                </div>
              </template>

              <template v-else>
                <ul>
                  <VList :data="option[nameElementItem]">
                    <template #default="{ item: suboption, index }">
                      <div :key="index">
                        <slot
                          name="subOption"
                          :item="suboption"
                        >
                          <f7-list class="search-list searchbar-found">
                            <div
                              class="content-list-checkbox-item"
                              :class="{
                                'checked': suboption.checked === true,
                                'disabled-checkbox': suboption.disabled === true,
                              }"
                            >
                              <label
                                v-if="showCheckbox"
                                class="checkbox"
                              >
                                <input
                                  :checked="suboption.checked"
                                  type="checkbox"
                                  @change="ChangeSelected(option, suboption)"
                                >
                                <i class="icon-checkbox" />
                              </label>
                              <div class="content-list-checkbox-item__details">
                                <f7-list-item link="#">
                                  {{ suboption[titleSubOption] }}
                                  <div v-if="'subOptionSubtitle' in $slots">
                                    <slot
                                      :item="suboption"
                                      name="subOptionSubtitle"
                                    />
                                  </div>
                                </f7-list-item>
                              </div>
                            </div>
                          </f7-list>
                        </slot>
                      </div>
                    </template>
                  </VList>
                </ul>
              </template>
            </f7-list>
            <UCPreload :show="option.hasOwnProperty('Preload') && option.Preload" />
          </f7-accordion-content>

          <!-- EN EL CASO DE QUE SE USE EL CHECKBOX -->

          <f7-accordion-content v-if="option.hasOwnProperty(nameElementItem) && searchWithCheckbox">
            <f7-list
              media-list
              class="search-list searchbar-found"
            >
              <div
                v-if="showCheckbox"
                class="content-checkbox-row padding-horizontal"
              >
                <div class="content-checkbox-row__check">
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      :checked="visibleItemsCheckStatus[i]"
                      :disabled="checkDisabled || option[nameElementItem].length === 0"
                      @change="CheckAllOption(option, $event.target.checked)"
                    >
                    <i class="icon-checkbox" />
                    {{
                      checkboxRowTitle in option
                        ? option[checkboxRowTitle]
                        : `${checkboxRowTitle} (${option[nameElementItem].length})`
                    }}
                  </label>
                </div>
                <div
                  v-if="afterIcon"
                  class="content-checkbox-row__actions"
                  :class="{ disabled: (disabledBtnOptionsNoItemsSelected && numberElementSelected === 0) }"
                  @click="OpenOption(option)"
                >
                  <img src="@/static/icons/ic_afterMenu.svg">
                </div>
              </div>

              <template v-if="!virtualList">
                <f7-list-item
                  v-for="(suboption, index) in option[nameElementItem]"
                  :key="index"
                >
                  <slot
                    name="subOption"
                    :item="suboption"
                  >
                    <div
                      class="content-list-checkbox-item"
                      :class="{
                        'checked': suboption.checked === true,
                        'disabled-checkbox': suboption.disabled === true,
                      }"
                    >
                      <label
                        v-if="showCheckbox"
                        class="checkbox"
                      >
                        <input
                          :checked="suboption.checked"
                          type="checkbox"
                          @change="ChangeSelected(option, suboption)"
                        >
                        <i class="icon-checkbox" />
                      </label>
                      <div
                        class="content-list-checkbox-item__details"
                      >
                        <f7-list-item
                          link="#"
                          :title="suboption[titleSubOption]"
                        >
                          <div v-if="'subOptionSubtitle' in $slots">
                            <slot
                              :item="suboption"
                              name="subOptionSubtitle"
                            />
                          </div>
                        </f7-list-item>
                      </div>
                    </div>
                  </slot>
                </f7-list-item>
              </template>

              <template v-else>
                <ul>
                  <VList :data="option[nameElementItem]">
                    <template #default="{ item: suboption, index }">
                      <f7-list-item :key="index">
                        <slot
                          name="subOption"
                          :item="suboption"
                        >
                          <div
                            class="content-list-checkbox-item"
                            :class="{
                              'checked': suboption.checked === true,
                              'disabled-checkbox': suboption.disabled === true,
                            }"
                          >
                            <label
                              v-if="showCheckbox"
                              class="checkbox"
                            >
                              <input
                                :checked="suboption.checked"
                                type="checkbox"
                                @change="ChangeSelected(option, suboption)"
                              >
                              <i class="icon-checkbox" />
                            </label>
                            <div class="content-list-checkbox-item__details">
                              <f7-list-item
                                link="#"
                                :title="suboption[titleSubOption]"
                              >
                                <div v-if="'subOptionSubtitle' in $slots">
                                  <slot
                                    :item="suboption"
                                    name="subOptionSubtitle"
                                  />
                                </div>
                              </f7-list-item>
                            </div>
                          </div>
                        </slot>
                      </f7-list-item>
                    </template>
                  </VList>
                </ul>
              </template>
            </f7-list>
            <UCPreload :show="option.hasOwnProperty('Preload') && option.Preload" />
          </f7-accordion-content>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UCPreload from '@/components/common/UCPreload.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';
import { VList } from 'virtua/vue';

/** @import { PropType } from 'vue' */

export default {
  name: 'UCAcordeon',

  components: {
    UCPreload,
    VList,
  },

  props: {
    title: { type: [String], default: null },
    items: { type: Array, default: () => [] },
    nameElementItem: { type: String, default: 'items' }, // nombre del elemento que contiene los items
    titleOption: { type: String, default: 'name' },
    titleSubOption: { type: String, default: 'name' },
    checkboxRowTitle: { type: String, default: 'name' },
    openedIndex: { type: Number, default: null },
    primary: { type: String, default: 'var(--his-dark-blue)' },
    secondary: { type: String, default: 'var(--hi-darkgray)' },
    fontColor: { type: String, default: 'var(--his-silver)' },
    badgeTextColor: { type: String, default: 'white' },
    showBadge: { type: Boolean, default: true },
    showCheckbox: { type: Boolean, default: false },
    chevronSide: { type: String, default: 'right' },
    closed: { type: Boolean, default: false },
    afterIcon: { type: Boolean, default: true },
    afterTitle: { type: Boolean, default: true },
    mostrarBuscador: { type: Boolean, default: false },
    searchWithCheckbox: { type: Boolean, default: false },
    disabledBtnOptionsNoItemsSelected: { type: Boolean, default: false },
    groupItems: { type: Boolean, default: false },
    groupKey: { type: [String, Number], default: null },
    searchInProps: {
      type: /** @type {PropType<string[]>} */ (Array),
      default: () => ['.title'],
    },
    functionCountBadge: { type: Function, default: null }, // Función que permite un calculo diferente para el indicador de elementos del acordeon.
    uncheckAllItemsOnEventAccordionClose: { type: Boolean, default: true }, // Permite controlar si se deseleccionan los elementos al cerrar el acordeón
    virtualList: { type: Boolean, default: false },
  },

  emits: [
    'change-selected',
    'open-options',
    'click-element-event',
    'index-selected',
    'checkAllOption',
    'accordionOpen',
  ],

  data() {
    return {
      checkedList: [], // lista de chequeados
      checkDisabled: false,
      searchValue: '',
    };
  },

  computed: {
    groupedItems() {
      if (!this.items || !this.groupItems || !this.groupKey) {
        return undefined;
      }

      const groupKeyProperties = this.groupKey.split('.');

      /** @type {any[]} */
      const groupedByKeyArray = this.items.reduce((acc, item) => {
        let groupKeyValue = item;
        groupKeyProperties.forEach((property) => {
          groupKeyValue = groupKeyValue[property];
        });
        acc[groupKeyValue] ||= { group: item[groupKeyProperties[0]], items: [] };
        acc[groupKeyValue].items.push(item);
        return acc;
      }, {});

      return Object.values(groupedByKeyArray);
    },

    visibleItems() {
      return this.groupedItems ?? this.items;
    },

    filteredVisibleItems() {
      if (!this.searchValue) {
        return this.visibleItems;
      }

      return this.visibleItems.map((item) => ({
        ...item,
        items: item[this.nameElementItem]?.filter((subItem) => this.searchInProps.some((prop) => {
          const value = this.GetNestedProp(subItem, prop);
          return value?.toLowerCase().includes(this.searchValue.toLowerCase());
        })) ?? [],
      }));
    },

    visibleItemsCheckStatus() {
      return this.filteredVisibleItems.map((item) => {
        const subItems = item[this.nameElementItem] ?? [];
        return subItems.length > 0 && subItems.every((subItem) => subItem.checked);
      });
    },

    customStyles() {
      return {
        '--custom-primary': this.primary,
        '--custom-secondary': this.secondary,
        '--custom-font-color': this.fontColor,
        '--custom-badge-text-color': this.badgeTextColor,
      };
    },

    numberElementSelected() {
      let count = 0;
      if (this.items.length === 0) {
        return count;
      }
      for (let i = 0; i < this.items.length; i += 1) {
        for (let j = 0; j < this.items[i].items.length; j += 1) {
          if (this.items[i].items[j].checked) {
            count += 1;
          }
        }
      }

      return count;
    },
  },

  watch: {
    mostrarBuscador(value) {
      if (!value) {
        f7.searchbar.clear();
      }
    },
  },

  mounted() {
    if (this.showCheckbox) {
      this.items.forEach((i) => {
        i.checkedAllItems = false;
        i.items.forEach((j) => {
          j.checked = false;
        });
      });
    }
  },

  methods: {
    isOpened(i) {
      return {
        'left-chevron': this.chevronSide === 'left',
        'accordion-item-opened': !this.closed || (i === this.openedIndex),
      };
    },

    /**
     * @template T
     * @param {Record<string, any>} object
     * @param {string} path
     * @returns {T | undefined}
     */
    GetNestedProp(object, path) {
      return path.split('.').reduce((acc, part) => acc?.[part], object);
    },

    /**
     * @public
     * @param {string} val - The id of the element.
     * @returns {boolean} `true` if the element is open, `false` otherwise.
     */
    ElementOpen(val) {
      if (document.getElementById(val).classList.contains('accordion-item-opened')) {
        return true;
      }
      return false;
    },

    ChangeSelected(option, suboption, state) {
      Log(this, this.ChangeSelected.name);

      suboption.checked = state === undefined ? !suboption.checked : state;
      this.$emit('change-selected', suboption);

      const allItemsChecked = option[this.nameElementItem].length > 0 ? option[this.nameElementItem].every((item) => item.checked) : false;
      option.checkedAllItems = allItemsChecked;
    },

    OpenOption(option) {
      Log(this, this.OpenOption.name);
      this.checkedList = [];

      option[this.nameElementItem].forEach((item) => {
        if (item.checked) {
          this.checkedList.push(item);
        }
      });

      this.$emit('open-options', this.checkedList);
    },

    EventClickOption(element, indexOpen) {
      Log(this, this.EventClickOption.name);
      this.$emit('click-element-event', element);
      this.$emit('index-selected', indexOpen);
    },

    ToggleCheckAllItems(option, state) {
      Log(this, this.ToggleCheckAllItems.name);

      if (option[this.nameElementItem].length > 0) {
        option[this.nameElementItem].forEach((e) => {
          this.ChangeSelected(option, e, state);
        });
      } else {
        option.checkedAllItems = state;
      }
    },

    CheckAllOption(option, state) {
      Log(this, this.CheckAllOption.name);
      this.ToggleCheckAllItems(option, state);
      this.$emit('checkAllOption', option[this.nameElementItem]);
    },

    EventAccordionOpen() {
      Log(this, this.EventAccordionOpen.name);
      this.$emit('accordionOpen');
    },

    EventAccordionClose(option) {
      Log(this, this.EventAccordionClose.name);
      if (this.uncheckAllItemsOnEventAccordionClose) {
        this.ToggleCheckAllItems(option, false);
      }
    },
  },
};
</script>

<style lang="scss">
.storybook-action-sorted-accordion {
  .accordion-list {
    --f7-list-item-title-text-color: var(--custom-font-color);
    --f7-badge-bg-color: var(--custom-secondary);
    --f7-badge-text-color: var(--custom-badge-text-color);

    .searchbar {
      margin: 0;
    }

    .sorted-accordion {
      > .item-inner {
        justify-content: flex-end;
        padding-right: 0;

        .item-link {
          width: 100%;
          justify-content: unset;
          background-color: var(--custom-primary);

          .ripple-wave {
            display: none;
          }

          .badge {
            margin-right: 10px;
          }

          .item-title {
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            padding-right: 40px;
          }
        }

        &::before {
          color: var(--custom-font-color);
        }

        .item-after {
          display: flex;
          align-items: center;
          background-color: var(--custom-primary);
          min-height: var(--f7-list-item-min-height);
        }
      }

      .accordion-item-content {
        .search-list {
          .item-content {
            padding-left: 8px;
          }
        }

        .content-item-row {
          > div:not(.main-info-row) {
            .item-inner {
              border-bottom: 1px solid var(--his-light-blue);
            }
          }

          > .storybook-action-sorted-accordion {
            .accordion-item {
              > .item-inner {
                display: flex;
                padding-top: 0;
                padding-bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  .list:not(.media-list) > ul > .accordion-item:not(.media-item) > .item-inner > .item-link::before,
  .list:not(.media-list) > ul > .accordion-item-opened:not(.media-item) > .item-inner > .item-link::before {
    font-family: "framework7-core-icons";
    font-weight: normal;
    font-style: normal;
    letter-spacing: normal;
    text-transform: none;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    text-align: center;
    display: block;
    position: absolute;
    top: 50%;
    font-size: var(--f7-list-chevron-icon-font-size);
    pointer-events: none;
    right: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-right));
    color: #fff;
    content: var(--f7-accordion-chevron-icon-down);
    width: 14px;
    height: 8px;
    margin-top: -3px;
    line-height: 8px;
  }

  .list:not(.media-list) > ul > .accordion-item-opened:not(.media-item) > .item-inner > .item-link::before {
    content: var(--f7-accordion-chevron-icon-up);
  }

  .left-chevron {
    .item-inner {
      .item-link {
        .item-title {
          padding-left: 25px !important;
        }

        .badge {
          margin-left: 25px;
        }

        &::before {
          left: 15px;
          right: 0;
          margin-top: -3px !important;
          margin-right: 15px;
        }
      }
    }
  }

  .content-checkbox-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--his-tierra-white);
    color: var(--his-oliva);
    font-size: 14px;
    padding: 5px;

    &__check label {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      i {
        margin-right: 12px;
      }
    }

    &__actions {
      height: 32px;
      width: 32px;
    }
  }

  .content-list-checkbox-item {
    --f7-list-item-padding-horizontal: 10px;

    padding: 0 8px;
    margin-bottom: 2px;
    border-top: 1px solid #ebebed;
    border-radius: 0;

    &__details {
      font-size: 20px !important;
      font-weight: 600 !important;

      .item-inner {
        color: var(--his-slate-blue);
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .disabled-checkbox {
    opacity: 0.7;
    pointer-events: none;
  }
}
</style>
